import BankAccountsChangelogTable from './components/BankAccountsChangelogTable';

const BankAccountsChangelog = () => {
  return <BankAccountsChangelogTable />;
};

export default BankAccountsChangelog;
